import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import { getMonthString } from '../../../../utils/timestamp';
import getDeadlineDisplayName from '../../../../utils/deadline';
import './styles.css';

export const splitDeadlines = (deadlines) => {
  const splitted = [];
  if (deadlines && deadlines.length > 0) {
    let secondColumnIndex = Math.floor(deadlines.length / 2);
    if (deadlines.length % 2 !== 0) {
      secondColumnIndex++;
    }
    splitted.push(deadlines.slice(0, secondColumnIndex));
    splitted.push(deadlines.slice(secondColumnIndex));
  }

  return splitted;
};

const getDeadlineAriaLabel = (deadline) => {
  return (
    getMonthString(Number(deadline.month) - 1) +
    ' ' +
    deadline.day +
    ' for ' +
    getDeadlineDisplayName(deadline)
  );
};

const DeadlinesTab = ({ deadlines, isCommonAppDeadlinesFlagOn }) => {
  const deadlinesColumn = 'deadlines-column';
  const deadlineContainer = 'deadline-container';
  const commonDeadlinesFlagOn = 'common-deadlines-flag-on';

  const splittedList = splitDeadlines(deadlines);
  return splittedList.length > 0 ? (
    <div
      className="application-information-tab deadlines-tab-container"
      data-cy="application-information-tab"
    >
      {splittedList.map(
        (deadlineList, index) =>
          deadlineList &&
          deadlineList.length > 0 && (
            <div
              className={
                /* istanbul ignore next */
                isCommonAppDeadlinesFlagOn
                  ? `${commonDeadlinesFlagOn} ${deadlinesColumn}`
                  : deadlinesColumn
              }
              key={`${index}-${getDeadlineDisplayName(deadlineList[0])}`}
            >
              {deadlineList.map(
                (deadline, index) =>
                  deadline && (
                    <div
                      className={
                        /* istanbul ignore next */
                        isCommonAppDeadlinesFlagOn
                          ? `${commonDeadlinesFlagOn} ${deadlineContainer}`
                          : deadlineContainer
                      }
                      data-cy="deadline-container"
                      tabIndex={0}
                      aria-label={getDeadlineAriaLabel(deadline)}
                      key={getDeadlineDisplayName(deadline) + index}
                      data-navi-donottranslate
                    >
                      <div className="deadline-calendar-container">
                        <div className="deadline-calendar-month">
                          {getMonthString(Number(deadline.month) - 1, true)}
                        </div>
                        <div className="deadline-calendar-date">
                          {
                            /* istanbul ignore next */ Number.isInteger(
                              Number(deadline.day),
                            )
                              ? deadline.day
                              : ''
                          }
                        </div>
                      </div>
                      <div className="deadline-text">
                        {getDeadlineDisplayName(deadline, isCommonAppDeadlinesFlagOn)}
                      </div>
                    </div>
                  ),
              )}
            </div>
          ),
      )}
    </div>
  ) : null;
};

DeadlinesTab.propTypes = {
  deadlines: PropTypes.array,
  isCommonAppDeadlinesFlagOn: PropTypes.bool,
};

export default injectIntl(DeadlinesTab);
